const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getSavedViews(orgId, type = null) {
  const params = new URLSearchParams();
  if (type) params.append('type', type);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/saved-views${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch saved views');
  }
  
  const data = await response.json();
  return data.views;
}

export async function createSavedView(orgId, viewData) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/saved-views`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(viewData)
  });
  
  if (!response.ok) {
    throw new Error('Failed to create saved view');
  }
  
  const data = await response.json();
  return data.view;
}

export async function deleteSavedView(orgId, viewId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/saved-views/${viewId}`, {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You can only delete your own saved views');
    }
    if (response.status === 404) {
      throw new Error('Saved view not found');
    }
    throw new Error('Failed to delete saved view');
  }
  
  return true;
}
